import { React, useContext } from "react";
import { Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  approveMultiple,
  getScenariosForApproval,
  setState,
} from "./scenarioApprovalSlice";


export default function ButtonGroup() {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const state = useSelector((store) => store.scenarioApproval);

  const {
    selectedRows,
    scenariosForApproval,
    scenariosForApprovalTable,
    selectedPeriod,
    selectedScenarioStatus,
    selectedCountryID,
    searchText
  } = state;

  function search() {
    dispatch(setState("scenarioDetails", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    const logedUser = JSON.parse(localStorage.getItem("data"));
    const period = selectedPeriod;
    const scenarioStatus = selectedScenarioStatus;
    const countryId = selectedCountryID;

    const obj = {
      logedUser,
      period,
      scenarioStatus,
      searchText,
      countryId,
    };
    dispatch(getScenariosForApproval(obj));
  }

  function approveSelected() {
    const user = JSON.parse(localStorage.getItem("data"));
    let scenarioList = [];
    for (let i = 0; i < selectedRows.length; ++i) {
      const id = selectedRows[i];
      const scenario = scenariosForApproval.find(
        (item) => item.scenarioID === id
      );
      const obj = {
        ...scenario,
        user,
      };
      scenarioList.push(obj);
    }
    console.log("Approve_Scenario_ApproveSelected", scenarioList);
    dispatch(approveMultiple(scenarioList)).then(() => {
      search();
    });
  }

  function openRejectionModal() {
    dispatch(setState("rejectMultiModalOpen", true));
  }

  return (
    scenariosForApprovalTable && (
      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Button
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            ml: 1,
            "&:hover": {
              bgcolor: "darkred.main",
              color: "white.main",
            },
          }}
          disabled={selectedRows.length === 0 || !isRestrictedAccess}
          onClick={approveSelected}
        >
          Approve Selected
        </Button>

        <Button
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            ml: 1,
            "&:hover": {
              bgcolor: "darkred.main",
              color: "white.main",
            },
          }}
          disabled={selectedRows.length === 0 || !isRestrictedAccess}
          onClick={openRejectionModal}
        >
          Reject Selected
        </Button>
      </Box>
    )
  );
}
